/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import SectionTitle from '@components/Headings/SectionTitle';
import HtmlBlock from '@components/UI/HtmlBlock';
import MidContainer from '@Layout/MidContainer';

/* Services */

/**
 * 
 * @param {Object} param0 
 * @returns 
 */
const WhoCanAttend = ({ section }) => {
  return (
    <Box
      width="100%"
      mt="0"
      mb="16px"
      p="30px 0 60px 0"
      bgColor="#F8F8F8"
    >
      <MidContainer w={'768'}>
        <SectionTitle titleObj={section?.sectionContent[0]} />
        <HtmlBlock sectionContent={section?.sectionContent[1]} />
      </MidContainer>
    </Box>
  );
};

export default WhoCanAttend;
